const state = {
  tokens: {
    authToken: null
  }
}

const getters = {
  getAuthToken: (state) => state.tokens.authToken,
  isAuthorized: (state) => !!state.tokens.authToken
}

const mutations = {
  setAuthToken(state, authToken) {
    state.tokens.authToken = authToken
  }
}

const actions = {
  setAuthToken(context, authToken) {
    context.commit('setAuthToken', authToken)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
